import {
  CATALOG_MANAGER_ROLES,
  CONFIGURATION_ROLES,
  LEAD_ASSIGNER_ROLES
} from '@crm/utils/permissions'

import { useRolePermission } from './useRolePermission'

/**
 * Capabilities of the current user, named after the business rule rather than
 * the role. Keeping the role lists in one place means a rule like "operators
 * cannot assign leads" is stated once instead of at each of its enforcement
 * points.
 */
export const useCapabilities = () => {
  const canAssignLeads = useRolePermission(LEAD_ASSIGNER_ROLES)
  const canManageCatalogs = useRolePermission(CATALOG_MANAGER_ROLES)
  const canAccessConfiguration = useRolePermission(CONFIGURATION_ROLES)

  return { canAssignLeads, canManageCatalogs, canAccessConfiguration }
}
